import { useState } from "react";

const images = [
  "https://public.readdy.ai/ai/img_res/076bacbf2dd3e322e733ee6c11a1069c.jpg",
  "https://readdy.ai/api/search-image?query=wireless%20earbuds%20charging%20case%20open%20white%20minimalist%20product%20photography%20studio%20clean%20background&width=600&height=600&seq=pdimg2&orientation=squarish",
  "https://readdy.ai/api/search-image?query=wireless%20earbuds%20side%20view%20detail%20shot%20white%20clean%20background%20product%20photography%20close%20up&width=600&height=600&seq=pdimg3&orientation=squarish",
  "https://readdy.ai/api/search-image?query=person%20wearing%20wireless%20earbuds%20lifestyle%20photo%20casual%20outdoor%20natural%20light%20happy&width=600&height=600&seq=pdimg4&orientation=squarish",
];

export default function ProductImages() {
  const [active, setActive] = useState(0);
  const [zoomed, setZoomed] = useState(false);

  return (
    <div className="flex flex-col gap-4">
      {/* Main Image */}
      <div
        className="relative aspect-square rounded-2xl overflow-hidden bg-gray-50 cursor-zoom-in"
        onClick={() => setZoomed(!zoomed)}
      >
        <img
          src={images[active]}
          alt="Product"
          className={`w-full h-full object-cover object-top transition-transform duration-300 ${zoomed ? "scale-150" : "scale-100"}`}
        />
        <div className="absolute top-3 left-3 flex flex-col gap-1.5">
          <span className="flex items-center gap-1 bg-white/90 text-green-600 text-xs font-semibold px-2.5 py-1 rounded-full">
            <i className="ri-shield-check-fill" /> Verified Factory
          </span>
          <span className="bg-orange-500 text-white text-xs font-semibold px-2.5 py-1 rounded-full">Best Seller</span>
        </div>
        <button className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-white/90 rounded-full cursor-pointer hover:bg-white">
          <i className="ri-heart-line text-gray-400 text-lg" />
        </button>
        <div className="absolute bottom-3 right-3 bg-black/40 text-white text-xs px-2 py-1 rounded-full">
          <i className="ri-zoom-in-line mr-1" />Click to zoom
        </div>
      </div>

      {/* Thumbnails */}
      <div className="flex gap-2">
        {images.map((img, i) => (
          <button
            key={i}
            onClick={() => { setActive(i); setZoomed(false); }}
            className={`w-16 h-16 rounded-lg overflow-hidden border-2 transition-colors cursor-pointer flex-shrink-0 ${active === i ? "border-orange-500" : "border-gray-200 hover:border-gray-300"}`}
          >
            <img src={img} alt={`View ${i + 1}`} className="w-full h-full object-cover object-top" />
          </button>
        ))}
      </div>
    </div>
  );
}
